import React, { Component } from 'react'
import { Button, Table, TableBody, TableCell, TableHead, TableRow, IconButton } from "@mui/material";
import { Container } from 'react-bootstrap';
import { formatDisplayDate, formatDate, sumMoney, displayStoredDate, partyLabel, transactionStatus, formatAmount } from '../../../helper';
import Select from '../../../Components/PCSelect';
import axios from "axios";
import Swal from "sweetalert2";
import RemoveIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import ReactToPrint from 'react-to-print';
import SaleInvoiceReport from '../../../Report/SaleInvoiceReport';
import PhoneClinicGrid from '../../../Components/PhoneClinicGrid';
import RowActions from '../../../Components/PhoneClinicGrid/RowActions';
import StatusChip from '../shared/StatusChip';
import { CARD, COL_HEAD, INPUT, LABEL, SELECT_STYLES, ToggleSwitch } from '../shared/txStyles';
import AmountInput from '../../../Components/AmountInput';
import PageHeader from '../shared/PageHeader';
/** @type {any} */
let _inventoryCache = null;

export default class SaleInvoice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            addSale: false,
            SaleList: [],
            ItemList: [],

            Customer: "",
            SALE_TO_TYPE: "Customer",

            Date: formatDate(new Date().toDateString()),
            Description: "",

            Item: {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            },

            AddedItemList: [],

            InventoryList: [],
            EMAIL_TO: "",
            isEdit: false,
            ShopList: [],
            AllWareHouseList: [],
            SaleToShop: "",
            SaleToWarehouse: "",
            OTHER_DATA: localStorage.getItem('OTHER_DATA')
        };
        this.gridRef = React.createRef(null);
    }


    componentDidMount() {
        // this.getData()
        // this.getInventory()
        // this.getShopList()
        // this.getWarehouseList()
    }


    async getShopList() {
        const getShops = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
        let shopData = getShops.data
        let ShopList = []
        if (shopData.success === 1) {
            for (let i = 0; i < shopData.data.length; i++) {
                const shop = shopData.data[i];
                ShopList.push({
                    value: shop.SP_NAME,
                    label: shop.SP_NAME
                })
            }
        }
        this.setState({ ShopList })
    }

    async getWarehouseList() {
        const getWarehouse = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllWarehouse.php`);
        let warehouseData = getWarehouse.data
        let AllWareHouseList = []
        if (warehouseData.success === 1) {
            for (let i = 0; i < warehouseData.data.length; i++) {
                const warehouse = warehouseData.data[i];
                AllWareHouseList.push({
                    value: warehouse.WAREHOUSE_NAME,
                    label: warehouse.WAREHOUSE_NAME
                })
            }
        }
        this.setState({ AllWareHouseList })
    }

    async getInventory() {
        if (_inventoryCache) {
            this.setState(_inventoryCache);
            return;
        }
        let formData = {
            PC_SP_ID: localStorage.getItem('PC_GRP_ATT') || 0
        };
        if (formData.PC_SP_ID !== 0) {
            const getAllInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/getInventory.php`, formData);
            let serviceData = getAllInventory.data
            let ItemList = []
            let InventoryList = []
            if (serviceData.success === 1) {
                InventoryList = serviceData.data
                for (let i = 0; i < InventoryList.length; i++) {
                    const element = InventoryList[i];
                    ItemList.push({
                        'label': `${element.DEVICE_ID || ""} ${element.INV_ITEM_NAME}`,
                        'value': element.INV_ITEM_NAME,
                        'id': element.INV_ID
                    })
                }
            }
            _inventoryCache = { InventoryList, ItemList };
            this.setState({ InventoryList, ItemList })
        }
    }

    hanldeAddSale() {
        this.setState({
            addSale: true
        })
        this.getInventory()
        this.getShopList()
        this.getWarehouseList()
    }

    handleUpdateSale(historyRow) {
        // let { SaleList } = this.state
        // let SaleData = SaleList[indx]
        // console.log('indx', indx)

        this.setState({
            isEdit: true,
            addSale: true,
            Customer: historyRow.SALE_CUSTOMER,
            SaleToShop: { value: historyRow.SALE_CUSTOMER, label: historyRow.SALE_CUSTOMER },
            SaleToWarehouse: { value: historyRow.SALE_CUSTOMER, label: historyRow.SALE_CUSTOMER },
            SALE_TO_TYPE: historyRow.SALE_TO_TYPE,
            Date: formatDate(historyRow.SALE_DATE),
            Description: historyRow.SALE_DESCRIPTION,
            AddedItemList: JSON.parse(historyRow.SALE_ITEM)

        })
    }

    handleChangeUpdatedItem(fieldName, evt, evtA) {
        let { Item, InventoryList } = this.state;
        Item['ItemQuantity'] = 1
        Item['ItemDisc'] = 0
        switch (fieldName) {
            case 'ItemName':
                let findInventory = InventoryList.filter(x => x.INV_ITEM_NAME === evt.value)?.[0]
                Item['ItemName'] = evt
                Item['ItemRate'] = parseInt(findInventory.PC_ITEM_SELL_RATE)
                Item['ItemIMEI'] = findInventory.INV_BARCODE
                Item['ItemAmount'] = parseInt(findInventory.PC_ITEM_SELL_RATE)
                Item['ItemDesc'] = findInventory.INV_DESC
                break;

            case 'ItemDisType':
                Item['ItemDisType'] = evtA
                if (evtA === 'number') {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - Item['ItemDisc']
                } else {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - ((Item['ItemQuantity'] * Item['ItemRate']) * (Item['ItemDisc'] / 100))
                }
                break;
            case 'ItemQuantity':
                Item[fieldName] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = (evt.target.value * Item['ItemRate']) - Item['ItemDisc']
                } else {
                    Item['ItemAmount'] = (evt.target.value * Item['ItemRate']) - ((evt.target.value * Item['ItemRate']) * (Item['ItemDisc'] / 100))
                }
                break;
            case 'ItemRate':
                Item[fieldName] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * evt.target.value) - Item['ItemDisc']
                } else {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * evt.target.value) - ((Item['ItemQuantity'] * evt.target.value) * (Item['ItemDisc'] / 100))
                }
                break;

            case 'ItemDisc':
                Item[fieldName] = evt.target.value
                // now setting relative condition
                if (Item['ItemDisType'] === 'number') {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - evt.target.value
                } else {
                    Item['ItemAmount'] = (Item['ItemQuantity'] * Item['ItemRate']) - ((Item['ItemQuantity'] * Item['ItemRate']) * (evt.target.value / 100))
                }
                break;

            case 'ItemIMEI':
                // let findInventory = InventoryList.filter(x => x.INV_BARCODE === evt.target.value || x.INV_BARCODE === evt.target.value)?.[0]
                Item[fieldName] = evt.target.value
                break;

            default:
                Item[fieldName] = evt.target.value
                break;

        }
        this.setState({ Item })
    }


    handleValidateItem(Item) {
        if (Item.ItemName === '' || Item?.ItemName?.value === "") {
            Swal.fire(
                'Error',
                'Please select Item',
                'error'
            )
            return false
        }
        if (Item.ItemRate === '' || parseInt(Item.ItemRate) <= 0) {
            Swal.fire(
                'Error',
                'Rate must be greater than 0',
                'error'
            )
            return false
        }
        if (Item.ItemQuantity === '' || parseInt(Item.ItemQuantity) <= 0) {
            Swal.fire(
                'Error',
                'Quantity must be greater than 0',
                'error'
            )
            return false
        }
        return true
    }

    handleAddItem() {
        let { Item, AddedItemList } = this.state
        if (!this.handleValidateItem(Item)) return
        let checkIfItemAvailable = AddedItemList.filter(x => x.ItemName.id === Item.ItemName.id)
        let CheckIndex = AddedItemList.findIndex(x => x.ItemName.id === Item.ItemName.id);
        if (checkIfItemAvailable.length > 0) {
            let AddedItemContent = checkIfItemAvailable[0]
            let CalculatedQuantity = parseInt(AddedItemContent['ItemQuantity']) + parseInt(Item['ItemQuantity']);
            AddedItemList[CheckIndex]['ItemDesc'] = Item['ItemDesc'];
            AddedItemList[CheckIndex]['ItemDisc'] = Item['ItemDisc'];
            AddedItemList[CheckIndex]['ItemDisType'] = Item['ItemDisType'];
            AddedItemList[CheckIndex]['ItemRate'] = Item['ItemRate'];
            AddedItemList[CheckIndex]['ItemQuantity'] = CalculatedQuantity;

            if (Item['ItemDisType'] === 'number') {
                Item['ItemAmount'] = (CalculatedQuantity * Item['ItemRate']) - Item['ItemDisc']
            } else {
                Item['ItemAmount'] = (CalculatedQuantity * Item['ItemRate']) - ((CalculatedQuantity * Item['ItemRate']) * (Item['ItemDisc'] / 100))
            }

            AddedItemList[CheckIndex]['ItemAmount'] = parseInt(Item['ItemAmount']);
            this.setState({ AddedItemList })
        } else {
            let UpdateItemList = [Item].concat(AddedItemList)
            this.setState({ AddedItemList: UpdateItemList })
        }
        let RefreshItem = {
            ItemName: "",
            ItemIMEI: "",
            ItemDesc: "",
            ItemRate: 0,
            ItemQuantity: 0,
            ItemDisc: 0,
            ItemAmount: 0,
            ItemDisType: "number"
        }
        this.setState({
            Item: RefreshItem
        })

    }

    handleChange(fieldName, evt) {
        let value
        switch (fieldName) {
            case 'SaleToShop':
            case 'SaleToWarehouse':
                // fieldName = "Customer"
                value = evt
                break;
            default:
                value = evt.target.value
                break;
        }
        this.setState({
            [fieldName]: value
        })
    }

    ValidateInvoice() {
        // if (this.state.Customer === "") {
        //     Swal.fire(
        //         'Error',
        //         'Please Enter Name',
        //         'error'
        //     )
        //     return false
        // }
        if (this.state.AddedItemList.length === 0) {
            Swal.fire(
                'Error',
                'Please Add atleast 1 Item',
                'error'
            )
            return false
        }
        return true
    }

    async handleSaveInvoice() {

        if (!this.ValidateInvoice()) return
        let { SALE_TO_TYPE } = this.state
        let formData = {
            SALE_BY: localStorage.getItem('PC_USR_NAME'),
            SALE_FROM: localStorage.getItem('PC_GRP_ATT'),
            SALE_CUSTOMER: SALE_TO_TYPE === 'Customer' ? this.state.Customer : SALE_TO_TYPE === 'Shop' ? this.state.SaleToShop?.value : this.state.SaleToWarehouse?.value,
            SALE_TO_TYPE: SALE_TO_TYPE,
            SALE_DATE: this.state.Date,
            SALE_DESCRIPTION: this.state.Description,
            SALE_STATUS: "Complete",
            SALE_ITEM: JSON.stringify(this.state.AddedItemList),
            SALE_TOTAL: this.renderTotalAmount()
        }

        let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCAddSale.php`, formData);
        if (getSaleInvoiceResult.data.status === 200) {
            Swal.fire(
                'Success',
                getSaleInvoiceResult.data.message,
                'success'
            )
        } else {
            Swal.fire(
                'Error',
                getSaleInvoiceResult.data.message,
                'error'
            )
        }
        this.setState({
            addSale: false,
            ItemList: [],

            WareHouseList: [{
                value: "F4",
                label: "F4"
            }],
            Customer: "",

            Date: formatDate(new Date().toDateString()),
            Description: "",
            Item: {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            },
            AddedItemList: [],
            isEdit: false
        })
        this.getData()
    }

    handleValidate() {
        if (this.state.EMAIL_TO === "") {
            Swal.fire(
                'Error',
                'Please Enter Email Address',
                'error'
            )
            return false
        }
        return true
    }

    async handleSendEmail() {

        if (!this.handleValidate()) return

        let formData = {
            SALE_BY: localStorage.getItem('PC_USR_NAME'),
            SALE_FROM: localStorage.getItem('PC_GRP_ATT'),
            SALE_CUSTOMER: this.state.Customer,

            SALE_DATE: this.state.Date,
            SALE_DESCRIPTION: this.state.Description,
            SALE_ITEM: JSON.stringify(this.state.AddedItemList),
            EMAIL_TO: this.state.EMAIL_TO
        }
        let getSaleInvoiceResult = await axios.post(`${process.env.REACT_APP_BASE_URL}mail/SendMail.php`, formData);
        if (getSaleInvoiceResult.data.status === 201) {
            Swal.fire(
                'Success',
                'Email has been send!!',
                'success'
            )
        }
    }

    handleExit() {
        this.setState({
            addSale: false,
            ItemList: [],

            Customer: "",

            Date: formatDate(new Date().toDateString()),
            Description: "",

            Item: {
                ItemName: "",
                ItemIMEI: "",
                ItemDesc: "",
                ItemRate: 0,
                ItemQuantity: 0,
                ItemDisc: 0,
                ItemAmount: 0,
                ItemDisType: "number"
            },

            AddedItemList: [],
            isEdit: false
        })
    }

    renderTotalAmount() {
        let { AddedItemList } = this.state;
        let Price = sumMoney(AddedItemList, "ItemAmount");
        return Price
    }

    handleKeyPress(evnt) {
        if (evnt.key === 'Enter') {
            this.handleAddItem()
        }
    }

    handleEnterImei(evnt) {
        if (evnt.key === 'Enter') {
            let { Item, InventoryList } = this.state;

            let FilterItem = InventoryList.filter(x => x.INV_BARCODE === Item.ItemIMEI)

            if (FilterItem.length > 0) {
                Item['ItemName'] = { value: FilterItem[0].INV_ITEM_NAME, label: FilterItem[0].INV_ITEM_NAME }
                Item['ItemDesc'] = FilterItem[0].INV_DESC
                Item['ItemRate'] = FilterItem[0].PC_ITEM_SELL_RATE
                Item['ItemQuantity'] = 1
                Item['ItemDisc'] = 0
                Item['ItemAmount'] = (FilterItem[0].PC_ITEM_QUANTITY * FilterItem[0].PC_ITEM_SELL_RATE) - ((FilterItem[0].PC_ITEM_QUANTITY * FilterItem[0].PC_ITEM_SELL_RATE) * (0 / 100))
            }

            this.setState({ Item }, () => { this.handleAddItem() })
        }

    }

    handleRemove(index) {
        let { AddedItemList } = this.state;
        AddedItemList.splice(index, 1)
        this.setState({ AddedItemList })
    }

    deleteSale(indx) {
        Swal.fire({
            title: 'Do you want to delete sale ?',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.props.toggleLoader(true)
                const getShops = await axios.post(`${process.env.REACT_APP_BASE_URL}services/delete/sale/DeleteShopSale.php`, { SALE_ID: indx });
                let shopData = getShops.data
                if (shopData.success === 1) {
                    Swal.fire(shopData.message, '', 'success')
                    this.getData()
                }
                this.props.toggleLoader(false)
            }
        })
    }

    async getData(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            PC_SP_ID: localStorage.getItem('PC_GRP_ATT') || 0,
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };
        const getAllSale = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllSale.php`, formData);
        let SaleData = getAllSale.data
        let SaleList = []
        if (SaleData.success === 1) {
            SaleList = SaleData.data
            pagination.totalItems = parseInt(SaleData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ SaleList })
        this.props.toggleLoader(false)
    }


    render() {
        const { addSale } = this.state;
        let { Item } = this.state;
        const isLocked = this.state.isEdit;

        if (!addSale) {
            return (
                <Container fluid style={{ padding: '24px' }}>
                    <PhoneClinicGrid
                        title="ITEM SALE"
                        buttonLabel="Add sale"
                        ref={this.gridRef}
                        getData={this.getData.bind(this)}
                        onClickButton={this.hanldeAddSale.bind(this)}
                        isEditable={true}
                        tableHeadData={[
                            { label: "DATE", isHidden: false },
                            { label: "SALE TO", isHidden: false },
                            { label: "STATUS", isHidden: false },
                            { label: "TOTAL PRICE", isHidden: false, align: 'right' },
                        ]}
                    >
                        {/* One row per record (flattened 2026-10-22). Columns follow the shared sale/purchase standard:
                            DATE | SALE TO or PURCHASE FROM as "Name (Type)" | DEVICE (device screens) | STATUS | TOTAL PRICE. */}
                        {this.state.SaleList.map((row, idx) => (
                            <TableRow key={idx}>
                                <TableCell>{displayStoredDate(row.SALE_DATE)}</TableCell>
                                <TableCell>{partyLabel(row.SALE_CUSTOMER, row.SALE_TO_TYPE)}</TableCell>
                                <TableCell><StatusChip label={transactionStatus(row, 'sale')} /></TableCell>
                                <TableCell align="right"><strong>£ {formatAmount(row.SALE_TOTAL)}</strong></TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'view', onClick: this.handleUpdateSale.bind(this, row) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </PhoneClinicGrid>
                </Container>
            );
        }

        return (
            <Container fluid style={{ padding: '24px', background: '#f8f9ff', minHeight: '100vh' }}>
                {/* Header */}
                <PageHeader title="Sale Invoice" right={<><ToggleSwitch
                        options={['Customer', 'Shop', 'Warehouse']}
                        value={this.state.SALE_TO_TYPE}
                        onChange={val => this.setState({ SALE_TO_TYPE: val })}
                        disabled={isLocked}
                    /></>} style={{ margin: "0 0 16px" }} />

                {/* Input Card */}
                {!isLocked && (
                    <div style={{ ...CARD, padding: 20, marginBottom: 16 }}>
                        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 2fr', gap: 16, marginBottom: 16 }}>
                            <div>
                                <label style={LABEL}>{this.state.SALE_TO_TYPE}</label>
                                {this.state.SALE_TO_TYPE === 'Customer'
                                    ? <input style={INPUT} value={this.state.Customer} onChange={this.handleChange.bind(this, 'Customer')} />
                                    : this.state.SALE_TO_TYPE === 'Shop'
                                        ? <Select menuPortalTarget={document.body} styles={SELECT_STYLES} menuPlacement="auto" value={this.state.SaleToShop} options={this.state.ShopList} onChange={this.handleChange.bind(this, 'SaleToShop')} />
                                        : <Select menuPortalTarget={document.body} styles={SELECT_STYLES} menuPlacement="auto" value={this.state.SaleToWarehouse} options={this.state.AllWareHouseList} onChange={this.handleChange.bind(this, 'SaleToWarehouse')} />
                                }
                            </div>
                            <div>
                                <label style={LABEL}>Date</label>
                                <input type="date" style={{ ...INPUT, background: '#f1f5f9', cursor: 'not-allowed' }} value={this.state.Date} disabled onChange={this.handleChange.bind(this, 'Date')} />
                            </div>
                            <div>
                                <label style={LABEL}>Description</label>
                                <input style={INPUT} value={this.state.Description} onChange={this.handleChange.bind(this, 'Description')} />
                            </div>
                        </div>
                        {/* Item entry */}
                        <div style={{ display: 'grid', gridTemplateColumns: '3fr 2fr 1fr 0.7fr', gap: 12, marginBottom: 12 }}>
                            <div>
                                <label style={LABEL}>Item</label>
                                <Select menuPortalTarget={document.body} styles={SELECT_STYLES} menuPlacement="auto" value={Item['ItemName']} options={this.state.ItemList} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemName')} />
                            </div>
                            <div>
                                <label style={LABEL}>IMEI / Barcode</label>
                                <input style={INPUT} value={Item['ItemIMEI']} onKeyPress={this.handleEnterImei.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemIMEI')} />
                            </div>
                            <div>
                                <label style={LABEL}>Rate</label>
                                <AmountInput plain style={INPUT} value={Item['ItemRate']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemRate')} />
                            </div>
                            <div>
                                <label style={LABEL}>Qty.</label>
                                <input type="number" style={INPUT} value={Item['ItemQuantity']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemQuantity')} />
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '3fr 1fr auto auto', gap: 12, alignItems: 'flex-end' }}>
                            <div>
                                <label style={LABEL}>Item Description</label>
                                <input style={INPUT} value={Item['ItemDesc']} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemDesc')} />
                            </div>
                            <div>
                                <label style={LABEL}>Discount</label>
                                <AmountInput plain style={INPUT} value={Item['ItemDisc']} onKeyPress={this.handleKeyPress.bind(this)} onChange={this.handleChangeUpdatedItem.bind(this, 'ItemDisc')} />
                            </div>
                            <div>
                                <label style={LABEL}>Type</label>
                                <ToggleSwitch
                                    options={['£', '%']}
                                    value={Item['ItemDisType'] === 'number' ? '£' : '%'}
                                    onChange={val => this.setState(prev => ({ Item: { ...prev.Item, ItemDisType: val === '£' ? 'number' : 'percent' } }))}
                                />
                            </div>
                            <Button variant="contained" style={{ height: 42, whiteSpace: 'nowrap' }} onClick={this.handleAddItem.bind(this)}>ADD ITEM</Button>
                        </div>
                    </div>
                )}

                {/* Table Card */}
                <div style={{ ...CARD, marginBottom: 16 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={COL_HEAD}>NAME</TableCell>
                                <TableCell style={COL_HEAD}>IMEI / BARCODE</TableCell>
                                <TableCell style={COL_HEAD}>RATE</TableCell>
                                <TableCell style={COL_HEAD}>QTY</TableCell>
                                <TableCell style={COL_HEAD}>DISCOUNT</TableCell>
                                <TableCell style={COL_HEAD}>AMOUNT</TableCell>
                                {!isLocked && <TableCell style={COL_HEAD}>ACTION</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.AddedItemList.map((ItemDetails, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>{ItemDetails.ItemName?.value}</TableCell>
                                    <TableCell>{ItemDetails.ItemIMEI}</TableCell>
                                    <TableCell>£ {formatAmount(ItemDetails.ItemRate)}</TableCell>
                                    <TableCell>{ItemDetails.ItemQuantity}</TableCell>
                                    <TableCell>{(ItemDetails.ItemDisc === '0' || ItemDetails.ItemDisc === 0) ? '' : (ItemDetails.ItemDisType === 'number' ? '£ ' + formatAmount(ItemDetails.ItemDisc) : '% ' + ItemDetails.ItemDisc)}</TableCell>
                                    <TableCell>£ {formatAmount(ItemDetails.ItemAmount)}</TableCell>
                                    {!isLocked && (
                                        <TableCell>
                                            <IconButton size="small" onClick={this.handleRemove.bind(this, idx)}><RemoveIcon /></IconButton>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                        <tfoot>
                            <tr>
                                <td colSpan={5} style={{ padding: '12px 16px', fontWeight: 700, color: '#64748b', fontSize: 12, textTransform: 'uppercase' }}>Net Sale</td>
                                <td style={{ padding: '12px 16px', fontWeight: 700, color: '#1e293b' }}>£ {formatAmount(this.renderTotalAmount())}</td>
                                {!isLocked && <td />}
                            </tr>
                        </tfoot>
                    </Table>
                </div>

                {/* Footer */}
                <div style={{ ...CARD, padding: '16px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Button variant="outlined" onClick={this.handleExit.bind(this)}>EXIT</Button>
                        {!isLocked && (
                            <Button variant="contained" onClick={this.handleSaveInvoice.bind(this)}>SAVE</Button>
                        )}
                    </div>
                    {isLocked && (
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                            <input style={{ ...INPUT, width: 200 }} value={this.state.EMAIL_TO} placeholder="Enter Email" onChange={this.handleChange.bind(this, 'EMAIL_TO')} />
                            <Button variant="outlined" onClick={this.handleSendEmail.bind(this)}>SEND EMAIL</Button>
                            <ReactToPrint
                                trigger={() => <Button variant="contained" color="tertiary" startIcon={<PrintIcon />}>PRINT</Button>}
                                content={() => this.printThermalSale}
                            />
                        </div>
                    )}
                </div>

                <SaleInvoiceReport
                    ref={el => (this.printThermalSale = el)}
                    data={{
                        ItemList: this.state.AddedItemList,
                        SaleDate: formatDisplayDate(this.state.Date),
                        SaleTo: this.state.SALE_TO_TYPE === 'Customer' ? this.state.Customer : this.state.SaleToShop?.value,
                        TotalAmount: this.renderTotalAmount(),
                        OTHER_DATA: this.state.OTHER_DATA
                    }}
                />
            </Container>
        );
    }
}
